var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { attrs: { gutter: 40 } },
    _vm._l(_vm.infoPair, function(info, j) {
      return _c("el-col", { key: j, attrs: { xs: 24, sm: 24, lg: 12 } }, [
        _c("div", { staticClass: "property load-up" }, [
          _c("div", { staticClass: "back" }, [
            _c("div", { staticClass: "diagonal", style: info.center.style }, [
              _c(
                "span",
                { staticStyle: { "font-size": "4em", color: "White" } },
                [_c("i", { class: info.center.icon })]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "front" }, [
            _c("div", { staticClass: "side" }, [
              _c("div", [
                _c("div", { staticClass: "top" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(info.left.label) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                !_vm.loadingProfile
                  ? _c(
                      "div",
                      { staticClass: "bottom" },
                      [
                        _c("count-to", {
                          staticClass: "card-panel-num",
                          attrs: {
                            "start-val": 0,
                            "end-val": info.left.value,
                            duration: 2600,
                            decimals: info.decimal ? info.numberOfDecimal : 0
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "unit" }, [
                          _vm._v(_vm._s(info.unit))
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "side" }, [
              _c("div", { staticClass: "align-right" }, [
                _c("div", { staticClass: "top" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(info.right.label) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                !_vm.loadingProfile
                  ? _c(
                      "div",
                      { staticClass: "bottom" },
                      [
                        _c("count-to", {
                          staticClass: "card-panel-num",
                          attrs: {
                            "start-val": 0,
                            "end-val": info.right.value,
                            duration: 2600,
                            decimals: info.decimal ? info.numberOfDecimal : 0
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "unit" }, [
                          _vm._v(_vm._s(info.unit))
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ])
          ])
        ])
      ])
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }